
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/impact-shop/basket",
      function () {
        return require("private-next-pages/impact-shop/basket.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/impact-shop/basket"])
      });
    }
  